// This file is generated by generate-build-info.js at build time; do not edit manually.
// It is overwritten on every build.
export const buildInfo = {
  name: 'registrator',
  version: '2.0.0',
  buildDate: '2026-11-04T07:32:20.193Z',
  commit: 'unknown',
  nodeVersion: 'v22.23.4',
  angularVersion: '20.2.1'
};
